import dataLayerHelper from '../helpers/dataLayer';

const $checkboxDiscount = $('.js-checkbox-discount');
const $checkboxDiscountInput = $('.js-checkbox-discount-input');
const $hidden = $('.js-checkbox-discount-hidden');

const checkboxDiscount = {
  initialize() {
    if ($checkboxDiscount.length) {
      this.createListeners();
    }
  },

  createListeners() {
    $checkboxDiscountInput.on('change', (e) => {
      const $target = $(e.currentTarget);
      const value = $target.data('discount');

      dataLayerHelper.event('Discount', 'click', $target[0].checked ? 'On' : 'Off');

      this.handleDiscount($target[0].checked ? value : 0);
    });
  },

  handleDiscount(val) {
    $hidden.val(val).trigger('change');
  },
};

export default checkboxDiscount;
